// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--jK2YG","text":"_7a3fb80146--text--qe0oS","info-icon":"_7a3fb80146--info-icon--eUMUD","rate":"_7a3fb80146--rate--tqpGH"};